export default __webpack_public_path__ + "static/media/4 - Кормушки для птиц.8f2aaa6c.jpg";